import { styled } from '@clickcease/cc-client-components-lib'

export const TableHeaderCounterStyled = styled('div', {
  display: 'flex',
  $fontSize: '$14',
})
export const TableHeaderCounterTitle = styled('div', {
  fontWeight: '$sb',
  marginRight: '$4',
})
export const TableHeaderCounterNumOfDomains = styled('div', {
  fontWeight: '$r',
})
export const TableHeaderCounterMaxNumOfDomains = styled('div', {
  color: '$lightNeutral',
})
